/**
 * Format date string to locale format
 * @param {string} dateString
 * @returns {string}
 */
export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short", 
    day: "numeric",
  });
};

/**
 * Format currency to JOD
 * @param {number} amount
 * @returns {string}
 */
export const formatCurrency = (amount) => {
  return `${amount} JOD`;
};

/**
 * Get payment status translation key
 * @param {string} status
 * @returns {string}
 */
export const getPaymentStatusKey = (status) => {
  switch (status) {
    case "PRE_CHECKOUT":
      return "customers.paymentStatus.preCheckout";
    case "PROCESSING_PAYMENT":
      return "customers.paymentStatus.processingPayment";
    case "PAYMENT_FAILED":
      return "customers.paymentStatus.paymentFailed";
    case "PAYMENT_SUCCESS":
      return "customers.paymentStatus.paymentSuccess";
    case "PENDING_CLIQ_PAYMENT_CONFIRMATION":
      return "customers.paymentStatus.pendingCliqConfirmation";
    default:
      return status; // Fallback to original status
  }
};

/**
 * Get user-friendly payment status text
 * @param {string} status
 * @returns {string}
 * @deprecated Use getPaymentStatusKey with i18n instead
 */
export const getPaymentStatusText = (status) => {
  switch (status) {
    case "PRE_CHECKOUT":
      return "Pre-Checkout";
    case "PROCESSING_PAYMENT":
      return "Processing Payment";
    case "PAYMENT_FAILED":
      return "Payment Failed";
    case "PAYMENT_SUCCESS":
      return "Payment Success";
    case "PENDING_CLIQ_PAYMENT_CONFIRMATION":
      return "Pending Cliq Confirmation";
    default:
      return status; // Fallback to original status
  }
};

/**
 * Get status badge styling classes
 * @param {string} status
 * @param {boolean} isActive
 * @returns {string}
 */
export const getStatusBadge = (status, isActive) => {
  if (isActive) {
    return "badge badge-success";
  }

  switch (status) {
    case "PAYMENT_SUCCESS":
      return "badge badge-success";
    case "PRE_CHECKOUT":
    case "PROCESSING_PAYMENT":
    case "PENDING_CLIQ_PAYMENT_CONFIRMATION":
      return "badge badge-warning";
    case "PAYMENT_FAILED":
      return "badge badge-error";
    default:
      return "badge badge-neutral";
  }
};

/**
 * Get payment method icon
 * @param {string} method
 * @returns {string}
 */
export const getPaymentIcon = (method) => {
  switch (method) {
    case "CARD":
      return "💳";
    case "CLIQ":
      return "💰";
    case "CASH":
      return "💵";
    default:
      return "💳";
  }
};